import { heicToBase64 } from './imageTypeConverter';
export const readImageFile = async (event: any) => {
  if (event.target.files && event.target.files.length > 0) {
    const reader: any = new FileReader();
    return await reader.readAsDataURL(event.target.files[0]);
  } else {
    return null;
  }
};

export const toBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const detectHEIC = async (imgSrc: string) => {
  if (
    imgSrc.toLowerCase().includes('image/heic') ||
    imgSrc.toLowerCase().includes('image/heif')
  ) {
    return await heicToBase64(imgSrc);
  } else {
    return imgSrc;
  }
};
